import React, { PropsWithChildren } from 'react';
import { Box } from '@mui/material';

// designed for use as the first child of a `StandardFloatingBox` only
export function FloatingBoxTopRightButton(props: PropsWithChildren) {
  return (
    <div style={{ position: 'relative' }}>
      <Box sx={{ position: 'absolute', top: '0', right: '8px', zIndex: 1 }}>{props.children}</Box>
    </div>
  );
}
